module.exports = __webpack_public_path__ + "static/media/Refresh Your Mesh in Maya.666f4a4d.png";